import { render, staticRenderFns } from "./viewRouter.vue?vue&type=template&id=7abf32c4"
import script from "./viewRouter.vue?vue&type=script&lang=js"
export * from "./viewRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports